// stringUtils.js

// Function to check email patterns
export function isValidEmail(email) {
  // Regular expression to validate email format
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return emailPattern.test(email);
}
